import { useEffect, useState } from 'react';

/**
 * Returns `true` on Windows, `false` everywhere else (macOS, Linux, web).
 *
 * Uses the Tauri `os` plugin under the hood, so it returns `false` on the
 * web build (where the plugin is unavailable) — the correct default for
 * Windows-only UI surfaces (e.g. Mica vibrancy gating).
 *
 * The result is `null` until the first async detection resolves; callers
 * that render conditionally should treat `null` the same as `false`.
 */
export function useIsWindows(): boolean | null {
  const [isWindows, setIsWindows] = useState<boolean | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { platform } = await import('@tauri-apps/plugin-os');
        const p = await platform();
        if (!cancelled) setIsWindows(p === 'windows');
      } catch {
        if (!cancelled) setIsWindows(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return isWindows;
}
